import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Add favicon to the tab if not already present
(function ensureFavicon() {
  let link = document.querySelector("link[rel='icon']") as HTMLLinkElement | null;
  if (!link) {
    link = document.createElement('link');
    link.rel = 'icon';
    document.head.appendChild(link);
  }
  link.href = '/favicon.ico';
})();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);